import React, { useMemo, useState } from "react";
import { F, CLSNAME, CLS } from "../data/aircraft";
import { STATS } from "../data/stats";
import { useNavigate } from "react-router-dom";
import { slugify } from "../lib/engine";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AircraftTile from "../components/AircraftTile";
import RequestModal from "../components/RequestModal";

const ORDER = ["heli", "turboprop", "light", "mid", "supermid", "large", "ulr", "bizliner", "group", "cargo", "piston"];

export default function FleetPage() {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [sort, setSort] = useState("size");
  const [cat, setCat] = useState("all");
  const [req, setReq] = useState(false);

  const list = useMemo(() => {
    const ql = q.trim().toLowerCase();
    let l = Object.keys(F).filter((fk) => (STATS[fk] || {}).n);
    if (cat !== "all") l = l.filter((fk) => F[fk].c === cat);
    if (ql) l = l.filter((fk) => { const f = F[fk]; return (f.n + " " + f.mk + " " + CLSNAME[f.c]).toLowerCase().includes(ql); });
    const key = { size: (fk) => -F[fk].t, range: (fk) => -F[fk].r, speed: (fk) => -F[fk].s, seats: (fk) => -((STATS[fk] || {}).mx || 0), name: null }[sort];
    l.sort((a, b) => (key ? key(a) - key(b) : F[a].n.localeCompare(F[b].n)));
    if (sort === "size") l.sort((a, b) => ORDER.indexOf(F[a].c) - ORDER.indexOf(F[b].c) || F[a].t - F[b].t);
    return l;
  }, [q, sort, cat]);

  return (
    <div className="sk">
      <Navbar onRequest={() => setReq(true)} />
      <main>
        <section className="block wrap">
          <div className="shead">
            <div><h2>Our fleet</h2><p>{list.length} aircraft types available through licensed Indian operators</p></div>
            <div className="fleettools">
              <input placeholder="Search aircraft, e.g. Legacy, King Air" value={q} onChange={(e) => setQ(e.target.value)} />
              <select value={cat} onChange={(e) => setCat(e.target.value)}>{Object.entries(CLS).map(([k, v]) => <option key={k} value={k}>{v.n}</option>)}</select>
              <select value={sort} onChange={(e) => setSort(e.target.value)}>
                <option value="size">Sort: cabin size</option><option value="range">Sort: longest range</option><option value="speed">Sort: fastest</option><option value="seats">Sort: most seats</option><option value="name">Sort: name</option>
              </select>
            </div>
          </div>
          <div className="grid">{list.length ? list.map((fk) => <AircraftTile key={fk} code={fk} onClick={() => nav(`/aircraft/${slugify(fk)}`)} />) : <div className="empty"><b>No aircraft match</b>Try another search.</div>}</div>
        </section>
      </main>
      <Footer />
      {req ? <RequestModal onClose={() => setReq(false)} /> : null}
    </div>
  );
}
